import { Container, Skeleton } from '@mui/material';
import React from 'react';
import AppBar from '../app-bar/AppBar';
import BackLink from '../back-link/BackLink';
import Breadcrumbs, { Breadcrumb } from '../breadcrumbs/Breadcrumbs';

const SimulationSkeleton = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => (
  <>
    <AppBar title="Exercise" />
    <Breadcrumbs items={breadcrumbs} sx={{ display: { xs: 'none', sm: 'flex' } }} />
    <Container sx={{ my: 4 }}>
      <BackLink label="Back to exercise" sx={{ display: { xs: 'inline-block', sm: 'none' }, my: 2 }} to=".." />

      <Skeleton height={195} variant="rounded" sx={{ mb: 8 }} />
    </Container>
  </>
);

export default SimulationSkeleton;
